<div class="tool-bar-container w-100 flex-wrap">
  <div class="d-flex tool-bar-types-with-search">
    <div class="tool-bar-types">
      <a
        class="tool-bar-list-type"
        [class.selected]="templateSelectorViewTypes.Grid === viewType"
        (click)="changeView(templateSelectorViewTypes.Grid)"
      >
        <i class="cc-icon cc-icon-grid"></i>
        <span i18n>Grid</span>
      </a>
      <a
        class="tool-bar-list-type"
        [class.selected]="templateSelectorViewTypes.Register === viewType"
        (click)="changeView(templateSelectorViewTypes.Register)"
      >
        <i class="cc-icon cc-icon-register"></i>
        <span i18n>Register</span>
      </a>
    </div>

    <cc-search-input
      [eventDebounceInMilliseconds]="searchDebounce"
      placeholder="Search templates..."
      [theme]="searchInputTheme"
      (valueChanged)="searchKeyword($event)"
    ></cc-search-input>

    <button *ngIf="showClearFiltersBtn" class="btn btn-sm btn-light sm-ml-1" (click)="clearFilters()" i18n>
      <i class="cc-icon cc-icon-undo"></i> Clear filters
    </button>
  </div>
</div>
